import { Widget } from '../../core/Widget.js';
import { VIEW_WIDGET_KEY } from '../../view/IViewWidget.js';
import { TABLE_WIDGET_KEY } from './ITableWidget.js';

// src/widgets/table/TableWidgetHelper.ts
class TableWidgetHelper {
    /**
     * Поиск таблицы по ключу
     * @param el элемент принадлежащий view в котором будет поиск (или само view)
     * @param tableKey ключ таблицы
     * @returns таблица
     */
    static findWithTableKey(el, tableKey) {
        const view = Widget.closestOnByName(el, VIEW_WIDGET_KEY);
        const tableEl = view?.findElementByDataKey(tableKey, true);
        if (!tableEl)
            return undefined;
        const table = Widget.getOnByName(tableEl, TABLE_WIDGET_KEY);
        return table;
    }
    /**
     * Сделать текущей строку по id (с опцией добавления к выделению).
     * Эквивалент легаси: $(...).imTable('currentRowByID', rowID)
     *
     * @param el      .im-table (или любой вложенный элемент)
     * @param rowID   data-id строки
     * @param append  добавлять к выделению (по умолчанию false)
     */
    static currentRowByID(el, rowID, append = false) {
        Widget.closestOnByName(el, TABLE_WIDGET_KEY)?.currentRowByID(rowID, { append, scroll: true });
    }
    /**
     * Вернуть список выделенных id через запятую (rowindexes).
     * Эквивалент легаси: $(...).imTable('checkedRowsIndexes')
     */
    static checkedRowsIndexes(el) {
        return Widget.closestOnByName(el, TABLE_WIDGET_KEY)?.checkedRowsIndexes() ?? '';
    }
    /**
     * Обновление строк таблицы.
     */
    static reload(el) {
        const crud = Widget.closestOnByName(el, TABLE_WIDGET_KEY)?.items.crud;
        if (crud)
            crud.reloadAll();
    }
    /**
     * Выделить все строки таблицы на указанном элементе .im-table.
     * Эквивалент легаси: $(...).imTable('checkAllRows')
     */
    static checkAllRows(host, tableKey, uiNotMask) {
        return this.findTableIn(host, tableKey, uiNotMask)?.items.selection?.selectAll();
    }
    /** Поиск таблицы по хосту */
    static findTableIn(host, tableKey, uiNotMask) {
        const mask = `[data-key="${tableKey}"]` + (uiNotMask ?? '');
        const tableHost = (host ? host.querySelector(mask) : document.querySelector(mask));
        if (!tableHost) {
            console.error(`Таблица ${tableKey} не найдена`);
            return undefined;
        }
        return Widget.getOnByName(tableHost, TABLE_WIDGET_KEY);
    }
}

export { TableWidgetHelper };
